import styled from "styled-components";

export const StyledAccentText = styled.span`
    color: ${({ theme }) => theme.additionalTypographyColor};
`;
